__turbopack_context__.v({
  "boxFirst": "bento-three-module-scss-module__gobqoG__boxFirst",
  "boxFirstContainer": "bento-three-module-scss-module__gobqoG__boxFirstContainer",
  "boxOneContent": "bento-three-module-scss-module__gobqoG__boxOneContent",
  "boxSecond": "bento-three-module-scss-module__gobqoG__boxSecond",
  "boxSecondContainer": "bento-three-module-scss-module__gobqoG__boxSecondContainer",
  "boxTwoContent": "bento-three-module-scss-module__gobqoG__boxTwoContent",
  "container": "bento-three-module-scss-module__gobqoG__container",
  "flexContainer": "bento-three-module-scss-module__gobqoG__flexContainer",
  "reverse": "bento-three-module-scss-module__gobqoG__reverse",
});
